'use strict';

angular.module('internal.licenses')
    .controller('InternalLicenseStatusesLevels', ['$scope', '$q', 'Licenses', 'LicenseCategories', 'LicenseCategoryCertificationStatuses', 'LicenseCategoryLevels', 'NREMTLevels', 'LicenseScheduledTasks','$stateParams', function ($scope, $q, Licenses, LicenseCategories, LicenseCategoryCertificationStatuses, LicenseCategoryLevels, NREMTLevels, LicenseScheduledTasks, $stateParams) {
        $scope.resetLicense();
        $scope.isStatusesOpen = true;
        $scope.isLevelsOpen = true;
        $scope.saving = false;
        $scope.statusesLoading = true;
        $scope.levelsLoading = true;
        $scope.nremtColumns = [
            {
                label: 'Level',
                field: 'name',
            }
        ]

        var a = LicenseCategoryCertificationStatuses.get({ license_category_id: $stateParams.licenseCategoryID }).then(function(licenseCategoryCertificationStatuses){
            $scope.license_category_certification_statuses = licenseCategoryCertificationStatuses;
        });

        $q.all([a]).then(function () {
            $scope.statusesLoading = false;
        }).catch(function (response) {
            // handle error
        });

        var b = LicenseCategoryLevels.get({ license_category_id: $stateParams.licenseCategoryID }).then(function (licenseCategoryLevels) {
            $scope.license_category_levels = licenseCategoryLevels;
        });

        var c = LicenseCategories.getByID($stateParams.licenseCategoryID).then(function (licenseCategory) {
            $scope.license_category = licenseCategory;
        })

        var d = NREMTLevels.get().then(function (nremtLevels) {
            $scope.nremtLevels = nremtLevels;
        })

        $q.all([b,c,d]).then(function () {
            $scope.levelsLoading = false;
        }).catch(function (response) {
            // handle error
        });

        $scope.add = function (array) {
            array.push({ license_category_id: $stateParams.licenseCategoryID });
        }

        $scope.remove = function (array, item) {
            array.splice(array.indexOf(item), 1);
        }

        $scope.checkAllStatuses = function (event, checkAll, options, license) {
            event.stopImmediatePropagation();
            license.license_category_certification_statuses = [];
            options.forEach(function (obj) {
                obj.checked = checkAll;
                if (checkAll) {
                    license.license_category_certification_statuses.push(obj);
                }
            })
        }

        $scope.checkAllLevels = function (event, checkAll, options, license) {
            event.stopImmediatePropagation();
            license.license_category_levels = [];
            options.forEach(function (obj) {
                obj.checked = checkAll;
                if (checkAll) {
                    license.license_category_levels.push(obj);
                }
            })
        }

        $scope.save = function () {
            $scope.saving = true;
            // Save license before levels and statuses. Potentially race if a level or status was added.
            var licenseProm = Licenses.save($scope.license);
            $scope.license.license_category.allow_multiple_levels = $scope.license_category.allow_multiple_levels;
            var licenseCategoryProm = LicenseCategories.updateAllowMultipleLevels($scope.license.license_category);

            $q.all([licenseProm, licenseCategoryProm]).then(function (data) {
                var license = data[0];
                $scope.setMasterLicense(license);
                var all = [];

                $scope.license_category_certification_statuses.forEach(function (license_category_certification_status, i) {
                    all.push(LicenseCategoryCertificationStatuses.save(license_category_certification_status, $scope.license.id).then(function (lccs) {
                        if (license_category_certification_status.id == null) {
                            $scope.license.license_category_certification_statuses.push(lccs);
                            $scope.masterLicense.license_category_certification_statuses.push(lccs);
                            $scope.license_category_certification_statuses[i].id = lccs.id;
                        }
                    }));
                })

                //If License Statuses are being removed from the License, make sure License_Scheduled_Task_Criteria_Status records that have the License_Category_Certification_Status ID Foreign Key are inactivated so Scheduled Tasks do not pick up records of statuses that have been removed
                all.push(LicenseScheduledTasks.saveStatuses($stateParams.licenseCategoryID,$scope.license.id));

                $scope.license_category_levels.forEach(function (license_category_level, i) {
                    all.push(LicenseCategoryLevels.save(license_category_level, $scope.license.id).then(function (lcl) {
                        if (license_category_level.id == null) {
                            $scope.license.license_category_levels.push(lcl);
                            $scope.masterLicense.license_category_levels.push(lcl);
                            $scope.license_category_levels[i].id = lcl.id;
                        }
                    }));
                })

                //If License Levels are being removed from the License, make sure License_Scheduled_Task_Criteria_Levels records that have the License_Category_Level ID Foreign Key are inactivated so Scheduled Tasks do not pick up records of levels that have been removed
                all.push(LicenseScheduledTasks.saveLevels($stateParams.licenseCategoryID, $scope.license.id));

                $q.all(all).then(function () {
                    $scope.saving = false;
                }).catch(function (response) {
                    // handle error
                });
            }).catch(function (response) {
                // handle error
            });
        }
    }])
;